/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { globalActions } from './globalSlice';

export const toggleSidebarOpen = (isOpen) => async dispatch => {
  dispatch(globalActions.toggleSidebarOpen(isOpen));
};

export const setPageTitle = (title) => async dispatch => {
  dispatch(globalActions.setPageTitle(title));
};

export const setFooterContent = (content) => async dispatch => {
  dispatch(globalActions.setFooterContent(content));
};

export const toggleFullScreenMode = (toggle) => async dispatch => {
  dispatch(globalActions.toggleFullScreenMode(toggle));
};

export const setObservatorySearchParams = (searchParams) => async dispatch => {
  dispatch(globalActions.setObservatorySearchParams(searchParams));
};
